import React, { Fragment, useState, useEffect } from "react";
import { Button, Col, Input, PopoverBody, Row, UncontrolledPopover } from "reactstrap";
import { filterDashboardTimePeriod } from "../../../constants/constants";
import { get } from "lodash";

const Dashboard = ({
    dashboardData,
    fetchDashboardData,
}) => {
    const [timePeriod, setTimePeriod] = useState(filterDashboardTimePeriod[0].id);

    useEffect(() => {
        fetchDashboardData(timePeriod);
    }, [timePeriod]);

    useEffect(() => {
        fetchDashboardData(timePeriod);
    }, []);

    const renderItem = (title, path) => {

        const currentValue = get(dashboardData, `current.${path}`);
        const previousValue = get(dashboardData, `previous.${path}`);

        return (
            <div className="row-alternate" style={{padding: '2px 3px'}}>
                <div
                    
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto 1fr',
                        alignItems: 'center',
                    }}
                >
                    <span style={{ justifySelf: 'start' }}>{title}: </span>
                    <span style={{ justifySelf: 'center' }}>
                        {isNaN(currentValue) ? '-' : (
                            Number.isInteger(currentValue)
                                ? currentValue
                                : currentValue?.toFixed(2)
                        )}
                    </span>
                    <span style={{ justifySelf: 'end' }}>
                        {getPercentChange(currentValue, previousValue)}
                    </span>
                </div>
            </div>
        );
        
    }

    const getPercentChange = (current, previous) => {
        const arrowStyle = { display: 'inline-block', width: 12, textAlign: 'end' };

        const formatValue = (value) => `${value > 0 ? '+' : ''}${value.toFixed(1)}%`;

        if (previous === 0) {
            return (
                <span style={{color: current === 0 ? 'white' : '#67FF84'}}>
                    <span>
                        {current === 0 ? '0%' : '+INFINITE%'}
                    </span>
                    <span style={arrowStyle}>
                        {current > 0 && '↑'}
                    </span>
                </span>
            );
            
            
        }

        const change = ((current - previous) / previous) * 100;
      const roundedChange = parseFloat(change.toFixed(1));

      if (change !== 0) {
            return (
                <span style={{color: change > 0 ? '#67FF84' : '#FF7D7D'}}>
                <span>
                        {formatValue(roundedChange)}
                    </span>
                    <span style={arrowStyle}>
                        {change > 0 ? '↑' : '↓'}
                    </span>
                </span>
            );
        }

        return (
            <span>
                <span>
                    0%
                </span>
                <span style={arrowStyle}></span>
            </span>
        );
    }

    return (
        <Fragment>
            <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-dashboard">
                <PopoverBody className="popover-body">
                    Overview data
                </PopoverBody>
            </UncontrolledPopover>

            <div className="admin-page-content">
                <Row>

                    <Col sm="10">
                        <h2>
                            Dashboard
                            <Button className="admin-help-button" id="admin-help-button-dashboard">
                                ?
                            </Button>
                        </h2>
                    </Col>

                    <Col sm="2">
                        Time Period
                        <Input
                            type="select"
                            id="timePeriod"
                            value={timePeriod}
                            onChange={(e) => setTimePeriod(e.target.value)}
                        >
                            {filterDashboardTimePeriod.map((item) => (
                                <option value={item.id}>{item.label}</option>
                            ))}
                        </Input>
                    </Col>
                </Row>

                <Row className="align-items-stretch">
                    <Col xs="4" className="d-flex mb-3">                        
                        <div class="d-flex flex-column w-100">
                            <h5>Moderation</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('Unread messages', 'moderation.unreadMessages')}
                                {renderItem('New Reported Players', 'moderation.newReportedPlayers')}
                                {renderItem('New Reported Messages', 'moderation.newReportedMessages')}
                                {renderItem('Non-Verified Accounts', 'moderation.nonVerifiedAccounts')}
                                {renderItem('Game Errors', 'moderation.gameErrors')}
                                {renderItem('Missed Turns', 'moderation.missedTurns')}
                            </div>
                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        
                        <div className="d-flex flex-column w-100">
                            <h5>Rooms (bets)</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('1:10', 'roomsBets.10')}
                                {renderItem('1:25', 'roomsBets.25')}
                                {renderItem('1:50', 'roomsBets.50')}
                                {renderItem('1:100', 'roomsBets.100')}
                                {renderItem('1:250', 'roomsBets.250')}
                                {renderItem('1:500', 'roomsBets.500')}
                                {renderItem('1:1000', 'roomsBets.1000')}
                                {renderItem('1:5000', 'roomsBets.5000')}
                                {renderItem('1:10000', 'roomsBets.10000')}
                            </div>
                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        <div className="d-flex flex-column w-100">
                            <h5>Rooms (speed, players)</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('Lightning', 'roomsSpeedAndPlayers.lightningGame')}
                                {renderItem('Very fast', 'roomsSpeedAndPlayers.veryFastGame')}
                                {renderItem('Fast', 'roomsSpeedAndPlayers.fastGame')}
                                {renderItem('Slow', 'roomsSpeedAndPlayers.slowGame')}
                                {renderItem('Unlimited', 'roomsSpeedAndPlayers.unlimitedGame')}

                                {renderItem('2-players', 'roomsSpeedAndPlayers.twoPRooms')}
                                {renderItem('3-players', 'roomsSpeedAndPlayers.threePRooms')}
                                {renderItem('4-players', 'roomsSpeedAndPlayers.fourPRooms')}
                            </div>
                            
                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        <div className="d-flex flex-column w-100">
                            <h5>Statistics</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('Rooms', 'statistics.rooms')}
                                {renderItem('New users', 'statistics.newUsers')}
                                {renderItem('Total players', 'statistics.totalPlayers')}
                                {renderItem('Active players', 'statistics.activePlayers')}
                                {renderItem('Deleted players', 'statistics.deletedPlayers')}
                                {renderItem('Online players', 'statistics.onlinePlayers')}
                                {renderItem('Gifts', 'statistics.gifts')}
                            </div>
                            
                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        <div className="d-flex flex-column w-100">
                            <h5>Suspicious</h5>
                            <div className="border border-white p-1 flex-fill">
                                {renderItem('Players', 'suspicious.players')}
                                {renderItem('Transactions', 'suspicious.transactions')}
                                {renderItem('Folds', 'suspicious.folds')}
                                {renderItem('Left rooms', 'suspicious.leftRooms')}
                                {renderItem('Possible bots', 'suspicious.possibleBots')}
                                {renderItem('One-gamers', 'suspicious.oneGamers')}
                            </div>
                            
                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        <div className="d-flex flex-column w-100">
                            <h5>Reports</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('Reported players', 'reports.reportedPlayers')}
                                {renderItem('Reported messages', 'reports.reportedMessages')}
                                {renderItem('Banned players', 'reports.bannedPlayers')}
                                {renderItem('Multi accounts', 'reports.multiAccounts')}
                            </div>
                            
                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        <div className="d-flex flex-column w-100">
                            <h5>Purchased Items</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('Unbanning account', 'purchasedItems.unbanningAccount')}
                                {renderItem('Remove ads (1 month)', 'purchasedItems.removeAdsMonths')}
                                {renderItem('Remove ads (year)', 'purchasedItems.removeAdsYear')}
                                {renderItem('VIP', 'purchasedItems.vip')}
                                {renderItem('Bronze ticket', 'purchasedItems.bronzeTicket')}
                                {renderItem('Silver ticket', 'purchasedItems.silverTicket')}
                                {renderItem('Gold ticket', 'purchasedItems.goldTicket')}
                            </div>
                            
                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        <div className="d-flex flex-column w-100">
                            <h5>Purchased Items</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('250Z', 'purchasedItems2.money1')}
                                {renderItem('500Z', 'purchasedItems2.money2')}
                                {renderItem('1000Z', 'purchasedItems2.money3')}
                                {renderItem('4000Z', 'purchasedItems2.money4')}
                                {renderItem('15000Z', 'purchasedItems2.money5')}

                                {renderItem('Reset profile', 'purchasedItems2.pack1')}
                                {renderItem('Reset balance', 'purchasedItems2.pack2')}
                                {renderItem('Reset points', 'purchasedItems2.pack3')}
                            </div>

                        </div>
                    </Col>

                    <Col xs="4" className="d-flex mb-3">
                        <div className="d-flex flex-column w-100">
                            <h5>Transactions</h5>

                            <div className="border border-white p-1 flex-fill">
                                {renderItem('Draugiem', 'transactions.draugiem')}
                                {renderItem('Facebook', 'transactions.facebook')}
                                {renderItem('Inbox', 'transactions.inbox')}
                                {renderItem('Web', 'transactions.web')}
                                {renderItem('iOS', 'transactions.iOS')}
                                {renderItem('Android', 'transactions.android')}
                                {renderItem('Total purchases', 'transactions.totalPurchases')}
                                {renderItem('Total amount', 'transactions.totalAmount')}
                            </div>

                        </div>
                    </Col>
                </Row>
            </div>
        </Fragment>
    )
}

export default Dashboard;
